import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Button from '../components/Button';
import Typography from '../components/Typography';
import productHowItWorks1 from '../components/img/productHowItWorks1.svg'
import productHowItWorks2 from '../components/img/productHowItWorks2.svg'
import productHowItWorks3 from '../components/img/productHowItWorks3.svg'
import VideoModal from '../components/VideoModal';
import productCurvyLines from "../components/img/productCurvyLines.png";

const item = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  px: 5,
};

const number = {
  fontSize: 24,
  fontFamily: 'default',
  color: 'secondary.main',
  fontWeight: 'medium',
};

const image = {
  height: 55,
  my: 4,
};

function ProductHowItWorks() {
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <Box
        component="section"
        sx={{ display: 'flex', bgcolor: 'secondary.light', overflow: 'hidden' }}
      >
        <Container
          sx={{
            mt: 10,
            mb: 15,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box
            component="img"
            src={productCurvyLines}
            alt="curvy lines"
            sx={{
              pointerEvents: 'none',
              position: 'absolute',
              top: -180,
              opacity: 0.7,
            }}
          />
          <Typography variant="h4" marked="center" component="h2" sx={{ mb: 14 }}>
            How it works
          </Typography>
          <div>
            <Grid container spacing={5}>
              <Grid item xs={12} md={4}>
                <Box sx={item}>
                  <Box sx={number}>1.</Box>
                  <Box
                    component="img"
                    src={productHowItWorks1}
                    alt="suitcase"
                    sx={image}
                  />
                  <Typography variant="h5" align="center">
                    Tell us which watch you are looking to buy.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box sx={item}>
                  <Box sx={number}>2.</Box>
                  <Box
                    component="img"
                    src={productHowItWorks2}
                    alt="graph"
                    sx={image}
                  />
                  <Typography variant="h5" align="center">
                    We will keep an eye on r/WatchExchange for you.
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box sx={item}>
                  <Box sx={number}>3.</Box>
                  <Box
                    component="img"
                    src={productHowItWorks3}
                    alt="clock"
                    sx={image}
                  />
                  <Typography variant="h5" align="center">
                    When your watch is posted, we will let you know ASAP!
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </div>
          <Button
            color="secondary"
            size="large"
            variant="contained"
            component="a"
            onClick={() => setOpen(true)}
            sx={{ mt: 8 }}
          >
            Watch a 100 second tutorial
          </Button>
        </Container>
      </Box>
      <VideoModal
        open={open}
        setOpen={setOpen}
      />
    </React.Fragment>
  );
}

export default ProductHowItWorks;